import styled from "styled-components";
import TextFields from "../UI/TextFields";
import ButtonUtil from "components/mobile/UI/ButtonUtil";
import { Fragment, useEffect, useState } from "react";
import SelectBox from "../UI/SelectBox";
import { callApi } from "util/HttpService";
import { alert, modalConfirm } from "./CmmnConfirm";
import CmmnRadio from "./CmmnRadioBox";

const TableWrap = styled.div`  
    @media (max-width: 1200px) {
        overflow: scroll;
    }
    &.mt-40 {
        margin-top: 40px;
    }
    h2 {
        font-size: 18px;
        color: #3b3b3b;
        font-weight: 500;
        margin-bottom: 15px;
    } 
`;
const InputTable = styled.div`
    // margin-bottom: 20px;
    border-top: 2px solid #EF2929;
    .input-table-th-small{
        max-width: 151px;
        min-width: 151px;
    }
    .input-table-wrap{
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgba(0,0,0,.1);
    }
    .col-2 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }
    .dp-flex {
        display: flex;
    }
`;
const DlBox = styled.div`
    width: ${props => {
        const length = props.$length;
        if (length === 1) return "50%";
        if (length === 2) return "33.3%";
        if (length === 3) return "25%";
        if (length === 4) return "20%";
        if (length === 5) return "16.6%";
        return "100%";
    }};
    border-right: 1px solid rgba(0,0,0,.1);
    & > div > div {
        width: 100% !important;
    }
`;
const InputTableHead = styled.div`
    background-color: #F3F3F3;
    padding: 20px;
    width: 30%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 80px;
    min-width: 191px;
    h3 {
        font-size: 16px;
        color: #3b3b3b;
        font-weight: 500;
        line-height: 150%;
        text-align: center;
    }
    &.single {
        width: 191px;
    }
    &.p-15 {
        padding: 15px;
    }
`;
const InputTableBody = styled.div`
    display: flex;
    align-items: center;
    padding: 20px;
    width: 100%;
    h4 {
        font-size: 16px;
        color: #3b3b3b;
        font-weight: 400;
    }
    h5 {
        font-size: 16px;
        color: #3b3b3b;
        font-weight: 500;
        margin-left: 10px;
    }
    .form-select {
        max-width: 250px;
    }
    input[type="number"], input[type="text"] {
        max-width: 250px;
        width: 250px;
    }
`;
const FrameTableHead = styled.div`
    background-color: #F3F3F3;
    padding: 20px;
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 78px;
    min-width: 151px;
    &:not(:last-child) {
        border-right: 1px solid rgba(0, 0, 0, 0.1);
    }
    h3 {
        font-size: 16px;
        color: #3b3b3b;
        font-weight: 500;
        line-height: 150%;
        text-align: center;
    }
`;
const FrameTableBody = styled.div`
    padding: ${(props) =>
        props.$cutYn
            ? props.$errors
                ? "0px 20px"
                : "1px 20px 19px 20px"
            : "20px"};
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 78px;
    min-width: 151px;
    flex-wrap: wrap;
    &:not(:last-child) {
        border-right: 1px solid rgba(0, 0, 0, 0.1);
    }
    .form-select {
        width: 100%;
        max-width: 300px;
    }
    input[type="text"] {
        width: 250px;
    }
    .description {
        width: 100%;
        p {
            font-size: 12px;
            color: #FF6B6B;
        }
    }
    .error-message {
        width: 100%;
        p {
            font-size: 12px;
            color: #ef2929;
        }
    }
    @media (min-width: 1700px) {
        padding: ${(props) =>
        props.$cutYn
            ? props.$errors
                ? "0px 20px"
                : "0px 20px 19px 20px"
            : "20px"};
        .description p,
        .error-message p {
            font-size: 13px;
        }
    }
`;
const BtnWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translate(-51%);
    .btn {
        width: 150px;
        max-width: 150px;
        &:first-child {
            margin-right: 10px;
        }
        &:nth-child(2) {
            margin-right: 10px;
            &:hover {
                color: var(--bs-btn-hover-color);
                background-color: var(--bs-btn-hover-bg);
                border-color: var(--bs-btn-hover-border-color);
            }
        }
        &:first-child:hover,
        &:last-child:hover {
            color: var(--bs-btn-hover-color) !important;
            background-color: var(--bs-btn-hover-bg) !important;
            border-color: var(--bs-btn-hover-border-color) !important;
        }
    }
    .round-filled-small-btn {
        background-color: ${({ theme }) => theme.colors.red} !important;
    }
`;
export default function ProgramConfig({
    t,
    brchClsfCd,
    systemMode,
    onHide,
    kiskInfo,
    data,
    getKiskInfo,
    setErrors,
    errors
}) {

    const [timeLimitSettings, setTimeLimitSettings] = useState({});
    const [printMarginSettings, setPrintMarginSettings] = useState({});
    const [framePaymentCntSettings, setFramePaymentCntSettings] = useState([]);
    const [filteredFrameArr, setFilteredFrameArr] = useState([]);
    const [paymentMethodSettings, setPaymentMethodSettings] = useState([]);

    useEffect(() => {
        if (kiskInfo && kiskInfo.eltmLmtnStupCn && kiskInfo.prntMrgnStupCn) {
            setTimeLimitSettings(kiskInfo.eltmLmtnStupCn);
            setPrintMarginSettings(kiskInfo.prntMrgnStupCn);
            setPaymentMethodSettings(kiskInfo.stlmMnsStupCn);
        }
    }, [kiskInfo]);

    const handleTimeLimitChange = (e, key) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setTimeLimitSettings(prevState => ({
            ...prevState,
            [key]: value
        }));
    };

    const handlePrintMarginChange = (e, key) => {
        const value = e.target.value;
        setPrintMarginSettings(prevState => ({
            ...prevState,
            [key]: value
        }));
    };

    const handleFrameSettingsChange = (e, frameCd) => {
        const { name, value } = e.target;

        // 숫자 필드 처리
        const numericFields = ["basePhotoCnt", "amtVal", "addAmtVal", "discntAmtVal", "takePhotoCnt"];
        const finalValue = numericFields.includes(name)
            ? value === "" ? "" : Number(value)
            : value;

        setFilteredFrameArr(prevState => {
            const newState = prevState.map(frame => {
                if (frame.frameCd === frameCd) {
                    return { ...frame, [name]: finalValue };
                }
                return frame;
            });
            return newState;
        });

        if (name === "basePhotoCnt") {
            setErrors(prevErrors => {
                const newErrors = { ...prevErrors };
                delete newErrors[frameCd];
                return newErrors;
            });
        }
    };

    const handlePaymentMethodChange = (method, field, value) => {
        setPaymentMethodSettings(prev => {
            const prevSettings = Array.isArray(prev) ? prev : [];
            const idx = prevSettings.findIndex(pm => pm.method === method);
            
            if( idx !== -1) {
                return prev.map(item =>
                    item.method === method
                        ? {
                            ...item,
                            options: {
                                ...item.options,
                                [field]: value
                            }
                        }
                        : item
                );
            } else {
                const newEntry = {
                    method,
                    options: {[field]: value}
                };
                return [...prevSettings,newEntry];
            }
        });
    };

    // 기본 제한 시간, 결제 대기 시간
    const basicLimitArray = Array.from({ length: 60 }, (_, i) => ({
        key: (i + 1) * 10,
        value: (i + 1) * 10,
    }));
    // 촬영 준비 시간
    const takeReadyLimitArray = Array.from({ length: 60 }, (_, i) => ({
        key: i + 1,
        value: i + 1,
    }));
    // 촬영 시간
    const takeLimitArray = Array.from({ length: 11 }, (_, i) => ({
        key: i + 1,
        value: i + 1,
    }));
    // 프레임 태그
    const frameTagArray = [
        { key: "HOT", value: "hot" },
        { key: "RECOMMEND", value: "recommend" },
    ];
    // 기본 통화
    const defaultCurrencyArray = [
        { key: "₩", value: "krw" },
        { key: "¥", value: "jpy" },
        { key: "$", value: "usd" },
        { key: "A$", value: "aud" },
    ];
    // 통화 기호 유형
    const currencyTypeArray = [
        { key: t("paymentMethodSetting.bill"), value: "paper" },
        { key: t("paymentMethodSetting.coin"), value: "coin" },
    ];
    // 촬영 소리 선택
    const photoTakeSoundArray = [
        { key: 'default', value: 'default' },
        { key: 'sound1', value: 'sound1' },
    ];

    // 원본 사진 기본 선택 여부
    const lblOrgImgDefaultSelectYnArray = [
        { key: t("paymentMethodSetting.lblOrgImgDefaultSelectY"), value: 'Y'},
        { key: t("paymentMethodSetting.lblOrgImgDefaultSelectN"), value: 'N'},
    ];

    // 카드 결제 선택 여부
    const cardYnArray = [
        { key: 'ON', value: 'true'},
        { key: 'OFF', value: 'false'},
    ];

    // QR 결제 선택 여부
    const qrYnArray = [
        { key:'ON', value: 't'},
        { key:'OFF', value: 'f'},
    ];

    const handleCmmnBtnClick = async (btnNm) => {
        // timeLimitSettings, printMarginSettings, framePaymentCntSettings, paymentMethodSettings 각각 호출
        switch (btnNm) {
            case "cmmnInsertBtn":
                try {
                    // bashPhotoCnt가 짝수일 때 리턴
                    // console.log(filteredFrameArr);
                    const errorMap = {};
                    filteredFrameArr.forEach(frame => {
                        if (frame?.frameInfo?.cutYn === 'Y') {
                            const value = parseInt(frame.basePhotoCnt);
                            if (value % 2 !== 0) {
                                errorMap[frame.frameCd] = t("prgmFrameSetting.errorEvenNumber");
                            }
                        }
                    });

                    if (Object.keys(errorMap).length > 0) {
                        setErrors(errorMap);
                        return;
                    } else {
                        setErrors({});
                    }

                    const commonParams = { brchId: data.brchId, eqmtId: data.eqmtId, eqmtNo: data.eqmtNo, delYn: 'N' };

                    // timeLimitSettings
                    const timeLimitParams = { ...commonParams, eltmLmtnStupCn: timeLimitSettings };
                    await callApi("POST", timeLimitParams, "/web/api/dvc-mgt/edm/kisk-insert");
                    console.log("전송된 timeLimitSettings : ", timeLimitParams);

                    // printMarginSettings
                    const printMarginParams = { ...commonParams, prntMrgnStupCn: printMarginSettings };
                    await callApi("POST", printMarginParams, "/web/api/dvc-mgt/edm/kisk-insert");
                    console.log("전송된 printMarginSettings : ", printMarginParams);

                    // framePaymentCntSettings
                    const updatedFramePaymentCntSettings = framePaymentCntSettings.map(payment => {
                        const updatedFrame = filteredFrameArr.find(frame => frame.frameCd === payment.frameCd);
                        return updatedFrame ? { ...payment, ...updatedFrame } : payment;
                    });
                    const framePaymentParams = { ...commonParams, frmeStlmCn: updatedFramePaymentCntSettings };
                    await callApi("POST", framePaymentParams, "/web/api/dvc-mgt/edm/kisk-insert");
                    console.log("전송된 framePaymentCntSettings : ", framePaymentParams);

                    // paymentMethodSettings
                    const paymentMethodParams = { ...commonParams, stlmMnsStupCn: paymentMethodSettings };
                    await callApi("POST", paymentMethodParams, "/web/api/dvc-mgt/edm/kisk-insert");
                    console.log("전송된 paymentMethodParams : ", paymentMethodParams);

                    alert("", t("alert.save"), () => { getKiskInfo() });

                } catch (error) {
                    console.log(error);
                    alert("", t("alert.saveError"), () => { return });
                }
                break;
            case "cmmnResetBtn":
                try {
                    modalConfirm("", t("alert.resetConfirm"), () => {
                        setTimeLimitSettings(kiskInfo.eltmLmtnStupCn);
                        setPrintMarginSettings(kiskInfo.prntMrgnStupCn);
                        fetchData();
                        alert("", t("alert.initSuccessAlert"), () => { });
                    })
                } catch (error) {
                    console.log(error);
                    alert("", t("alert.initFailAlert"), () => { });
                }
                break;
            default: break;
        };
    };

    const fetchData = async () => {
        if (kiskInfo && kiskInfo.frmeStupCn && kiskInfo.frmeStlmCn) {
            // bf-pks-app에서는 frameSettings를 db의 frme_stup_cn컬럼이 아닌 frameSettings.json를 만들어 사용중임.
            // 여기서는 frameSettings.json을 대신해 사용한것이 db의 frme_stup_cn컬럼
            const frameSettings = kiskInfo.frmeStupCn;
            const tmpFramePaymentCntSettings = kiskInfo.frmeStlmCn;
            setFramePaymentCntSettings(tmpFramePaymentCntSettings);

            const filteredFrames = frameSettings.filter(frame =>
                Array.isArray(frame.systemModeArr)
                && frame.systemModeArr.includes(systemMode.value)
            );

            // framePaymentCntSettings에서 filteredFrames의 frameCd가 있는 항목만 추출하여 filteredFrames에 추가
            const frameCdSet = new Set(filteredFrames.map(frame => frame.frameCd));
            const filteredPaymentSettings = tmpFramePaymentCntSettings.filter(payment => frameCdSet.has(payment.frameCd));
            // console.log("filteredPaymentSettings : ", filteredPaymentSettings);

            // filteredFrames에 amtVal 등의 정보 추가
            const mergedFrames = await Promise.all(filteredFrames.map(async frame => {
                const paymentInfo = filteredPaymentSettings.find(payment => payment.frameCd === frame.frameCd);
                return { ...frame, ...paymentInfo };
            }));

            const finalFrames = mergedFrames.flat();
            // console.log("finalFrames : ", finalFrames);
            setFilteredFrameArr(finalFrames);
        }
    };

    useEffect(() => {
        fetchData();
    }, [kiskInfo]);

    useEffect(() => {
        console.log(filteredFrameArr);
    }, [filteredFrameArr]);

    const getPaymentMethodOptions = (method) => {
        if (!Array.isArray(paymentMethodSettings)) return {};
    
        const option = paymentMethodSettings.find(pm => pm.method === method)?.options;
    
        if (!option) {
            if (method === 'cash') return { currencyType: 'coin', cashUseMinAmount: '' };
            if (method === 'base') return { defaultCurrency: 'jpy', orgImgDownAmtVal: 100 };
        }
    
        return option;
    };

    return (
        <>
            <div className="p-30">
                <TableWrap>
                    <h2>{t("prgmLimitTimeSetting.title")}</h2>
                    <InputTable>
                        <div className="col-2">
                            <div className="input-table-wrap w-50">
                                <InputTableHead>
                                    <h3>{t("prgmLimitTimeSetting.lblDefLimitTimeSet")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <div className="dp-flex align-cen w-100">
                                        <SelectBox
                                            defaultOptTxt={t("common.selectLable")}
                                            dataArray={basicLimitArray}
                                            onSelectChange={(e) => handleTimeLimitChange(e, 'basicLimit')}
                                            tagName="basicLimit"
                                            defaultVal={timeLimitSettings.basicLimit || 60}
                                        />
                                        <h5>{t("common.seconds")}</h5>
                                    </div>
                                </InputTableBody>
                            </div>
                            <div className="input-table-wrap w-50">
                                <InputTableHead>
                                    <h3>{t("prgmLimitTimeSetting.lblTakeReadyLimitTimeSet")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <div className="dp-flex align-cen w-100">
                                        <SelectBox
                                            defaultOptTxt={t("common.selectLable")}
                                            dataArray={takeReadyLimitArray}
                                            onSelectChange={(e) => handleTimeLimitChange(e, 'takeReadyLimit')}
                                            tagName="takeReadyLimit"
                                            defaultVal={timeLimitSettings.takeReadyLimit || 60}
                                        />
                                        <h5>{t("common.seconds")}</h5>
                                    </div>
                                </InputTableBody>
                            </div>
                        </div>
                        <div className="col-2">
                            <div className="input-table-wrap w-50">
                                <InputTableHead>
                                    <h3>{t("prgmLimitTimeSetting.lblPaymentLimitTimeSet")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <div className="dp-flex align-cen w-100">
                                        <SelectBox
                                            defaultOptTxt={t("common.selectLable")}
                                            dataArray={basicLimitArray}
                                            onSelectChange={(e) => handleTimeLimitChange(e, 'paymentLimit')}
                                            tagName="paymentLimit"
                                            defaultVal={timeLimitSettings.paymentLimit || 60}
                                        />
                                        <h5>{t("common.seconds")}</h5>
                                    </div>
                                </InputTableBody>
                            </div>
                            <div className="input-table-wrap w-50">
                                <InputTableHead>
                                    <h3>{t("prgmLimitTimeSetting.lblTakePhotoLimitTimeSet")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <div className="dp-flex align-cen w-100">
                                        <SelectBox
                                            defaultOptTxt={t("common.selectLable")}
                                            dataArray={takeLimitArray}
                                            onSelectChange={(e) => handleTimeLimitChange(e, 'takeLimit')}
                                            tagName="takeLimit"
                                            defaultVal={timeLimitSettings.takeLimit || 60}
                                        />
                                        <h5>{t("common.seconds")}</h5>
                                    </div>
                                </InputTableBody>
                            </div>
                        </div>
                        <div className="input-table-wrap w-100">
                            <InputTableHead className="single">
                                <h3>{t("prgmLimitTimeSetting.lblPhotoTakeSound")}</h3>
                            </InputTableHead>
                            <InputTableBody>
                                <div className="dp-flex align-cen w-100">
                                    <SelectBox
                                        defaultOptTxt={t("common.selectLable")}
                                        dataArray={photoTakeSoundArray}
                                        onSelectChange={(e) => handleTimeLimitChange(e, 'photoTakeSound')}
                                        tagName="photoTakeSound"
                                        defaultVal={timeLimitSettings.photoTakeSound || 'sound1'}
                                    />
                                </div>
                            </InputTableBody>
                        </div>
                    </InputTable>
                </TableWrap>
                <TableWrap className="mt-40">
                    <h2>{t("prgmPrintWhiteSpaceSetting.title")}</h2>
                    <InputTable>
                        <div className="col-2"> 
                            <div className="input-table-wrap w-50">
                                <InputTableHead className="mh-88">
                                    <h3>{t("prgmPrintWhiteSpaceSetting.lblTopWs")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <div className="dp-flex align-cen w-100">
                                        <TextFields
                                            type="number"
                                            name="hTopMargin"
                                            onChangeValue={(e) => handlePrintMarginChange(e, 'hTopMargin')}
                                            value={printMarginSettings?.hTopMargin || ""}
                                        />
                                        <h5>px</h5>
                                    </div>
                                </InputTableBody>
                            </div>
                            <div className="input-table-wrap w-50">
                                <InputTableHead className="mh-88">
                                    <h3>{t("prgmPrintWhiteSpaceSetting.lblLeftWs")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <div className="dp-flex align-cen w-100">
                                        <TextFields
                                            type="number"
                                            name="hLeftMargin"
                                            onChangeValue={(e) => handlePrintMarginChange(e, 'hLeftMargin')}
                                            value={printMarginSettings?.hLeftMargin || ""}
                                        />
                                        <h5>px</h5>
                                    </div>
                                </InputTableBody>
                            </div>
                        </div>
                    </InputTable>
                </TableWrap>
                {brchClsfCd === "KSC" && Array.isArray(paymentMethodSettings) && paymentMethodSettings.length > 0 && (
                    <TableWrap className="mt-40">
                        <h2>{t("paymentMethodSetting.title")}</h2>
                        <InputTable>
                            <div className="col-2">
                                <div className="input-table-wrap w-50">
                                    <InputTableHead>
                                        <h3>{t("paymentMethodSetting.lblCurrencyType")}</h3>
                                    </InputTableHead>
                                    <InputTableBody>
                                        <div className="dp-flex align-cen w-100">
                                            <CmmnRadio
                                                tagName="currencyType"
                                                dataArray={currencyTypeArray}
                                                defaultVal={getPaymentMethodOptions("cash")?.currencyType || 'coin'}
                                                onSelectChange={(e) => handlePaymentMethodChange('cash', 'currencyType', e.target.value)}
                                            />
                                        </div>
                                    </InputTableBody>
                                </div>
                                <div className="input-table-wrap w-50">
                                    <InputTableHead className="p-15">
                                        <h3>{t("paymentMethodSetting.lblCashUseMinAmount")}</h3>
                                    </InputTableHead>
                                    <InputTableBody>
                                        <div className="dp-flex align-cen w-100">
                                            <TextFields
                                                type="text"
                                                name="cashUseMinAmount"
                                                value={String(getPaymentMethodOptions('cash')?.cashUseMinAmount || '')}
                                                onChangeValue={(e) => handlePaymentMethodChange('cash', 'cashUseMinAmount', e.target.value)}
                                                placeholder={t("paymentMethodSetting.phCashUseMinAmount")}
                                            />
                                        </div>
                                    </InputTableBody>
                                </div>
                            </div>
                            <div className="col-2">
                                <div className="input-table-wrap w-50">
                                    <InputTableHead className="p-15">
                                        <h3>{t("paymentMethodSetting.lblDefaultCurrency")}</h3>
                                    </InputTableHead>
                                    <InputTableBody>
                                        <div className="dp-flex align-cen w-100">
                                            <SelectBox
                                                defaultOptTxt={t("common.selectLable")}
                                                dataArray={defaultCurrencyArray}
                                                onSelectChange={(e) => handlePaymentMethodChange('base', 'defaultCurrency', e.target.value)}
                                                tagName="defaultCurrency"
                                                defaultVal={getPaymentMethodOptions('base')?.defaultCurrency || 'jpy'}
                                            />
                                        </div>
                                    </InputTableBody>
                                </div>
                                <div className="input-table-wrap w-50">
                                    <InputTableHead className="p-15">
                                        <h3>{t("paymentMethodSetting.orgPhotoDownloadPrice")}</h3>
                                    </InputTableHead>
                                    <InputTableBody>
                                        <div className="dp-flex align-cen w-100">
                                            <TextFields
                                                type="number"
                                                name="orgImgDownAmtVal"
                                                value={getPaymentMethodOptions('base')?.orgImgDownAmtVal}
                                                onChangeValue={(e) => handlePaymentMethodChange('base', 'orgImgDownAmtVal', e.target.value)}
                                            />
                                        </div>
                                    </InputTableBody>
                                </div>
                            </div>
                            <div className="col-2">
                                <div className="input-table-wrap w-50">
                                    <InputTableHead className="single">
                                        <h3>{t("paymentMethodSetting.WeblblOrgImgDefaultSelectYn")}</h3>
                                    </InputTableHead>
                                    <InputTableBody>
                                        <div className="dp-flex align-cen w-100">
                                            <CmmnRadio
                                                    tagName="orgImgDownDefaultSelect"
                                                    dataArray={lblOrgImgDefaultSelectYnArray}
                                                    defaultVal={getPaymentMethodOptions("base")?.orgImgDownDefaultSelect || 'Y'}
                                                    onSelectChange={(e) => handlePaymentMethodChange('base', 'orgImgDownDefaultSelect', e.target.value)}
                                                />
                                        </div>
                                    </InputTableBody>
                                </div>
                                {/* 카드 결제 Y/N */}
                                <div className="input-table-wrap w-50">
                                    <InputTableHead className="single">
                                        <h3>{t("paymentMethodSetting.cardPayment")}</h3>
                                    </InputTableHead>
                                    <InputTableBody>
                                        <div className="dp-flex align-cen w-100">
                                            <CmmnRadio
                                                    tagName="enabled"
                                                    dataArray={cardYnArray}
                                                    defaultVal={getPaymentMethodOptions("card")?.enabled === true ? 'true': getPaymentMethodOptions("card")?.enabled === false ? 'false':'' || '' }
                                                    onSelectChange={(e) => handlePaymentMethodChange('card', 'enabled', e.target.value === "true" ? true:false)}
                                                />
                                        </div>
                                    </InputTableBody>
                                </div>
                            </div>
                            <div className="col-2">
                                {/* KSNET 카드 단말 번호 */}
                                <div className="input-table-wrap w-50">
                                    <InputTableHead className="p-15">
                                        <h3>{t("paymentMethodSetting.ksNetCardTerminalNum")}</h3>
                                    </InputTableHead>
                                    <InputTableBody>
                                        <TextFields
                                            type="text"
                                            name="ksNetCardReaderDeviceNo"
                                            value={getPaymentMethodOptions('card')?.ksNetCardReaderDeviceNo}
                                            onChangeValue={(e) => handlePaymentMethodChange('card','ksNetCardReaderDeviceNo',e.target.value)}
                                        />
                                    </InputTableBody>
                                </div>
                                {/* KSNET 연동 포트번호 */}
                                <div className="input-table-wrap w-50">
                                    <InputTableHead className="p-15">
                                        <h3>{t("paymentMethodSetting.ksNetLinkPortNum")}</h3>
                                    </InputTableHead>
                                    <InputTableBody>
                                        <TextFields
                                            type="text"
                                            name="ksNetLnkgPort"
                                            value={getPaymentMethodOptions('card')?.ksNetLnkgPort}
                                            onChangeValue={(e) => handlePaymentMethodChange('card','ksNetLnkgPort',e.target.value)}
                                        />
                                    </InputTableBody>
                                </div>
                            </div>
                            <div className="col-2">
                                {/* QR 결제 여부 */}
                                <div className="input-table-wrap w-100">
                                    <InputTableHead className="single">
                                        <h3>{t("paymentMethodSetting.qrPayment")}</h3>
                                    </InputTableHead>
                                    <InputTableBody>
                                        <div className="dp-flex align-cen w-100">
                                            <CmmnRadio
                                                    tagName="qrEnabled"
                                                    dataArray={qrYnArray}
                                                    defaultVal={getPaymentMethodOptions("qr")?.enabled === true ? 't': getPaymentMethodOptions("qr")?.enabled === false ? 'f':'' || '' }
                                                    onSelectChange={(e) => handlePaymentMethodChange('qr', 'enabled', e.target.value === "t" ? true:false)}
                                                />
                                        </div>
                                    </InputTableBody>
                                </div>
                            </div>
                        </InputTable>
                    </TableWrap>
                )}
                {brchClsfCd === "FCC" && Array.isArray(paymentMethodSettings) && paymentMethodSettings.length > 0 && (
                    <TableWrap className="mt-40">
                        <h2>{t("paymentMethodSetting.title")}</h2>
                        <InputTable>
                            <div className="col-2">
                                <div className="input-table-wrap w-50">
                                    <InputTableHead className="p-15">
                                        <h3>{t("paymentMethodSetting.orgPhotoDownloadPrice")}</h3>
                                    </InputTableHead>
                                    <InputTableBody>
                                        <div className="dp-flex align-cen w-100">
                                            <TextFields
                                                type="number"
                                                name="orgImgDownAmtVal"
                                                value={getPaymentMethodOptions('base')?.orgImgDownAmtVal}
                                                onChangeValue={(e) => handlePaymentMethodChange('base', 'orgImgDownAmtVal', e.target.value)}
                                            />
                                        </div>
                                    </InputTableBody>
                                </div>
                                <div className="input-table-wrap w-50">
                                    <InputTableHead className="p-15">
                                        <h3>{t("paymentMethodSetting.WeblblOrgImgDefaultSelectYn")}</h3>
                                    </InputTableHead>
                                    <InputTableBody>
                                        <div className="dp-flex align-cen w-100">
                                            <CmmnRadio
                                                    tagName="orgImgDownDefaultSelect"
                                                    dataArray={lblOrgImgDefaultSelectYnArray}
                                                    defaultVal={getPaymentMethodOptions("base")?.orgImgDownDefaultSelect || 'Y'}
                                                    onSelectChange={(e) => handlePaymentMethodChange('base', 'orgImgDownDefaultSelect', e.target.value)}
                                                />
                                        </div>
                                    </InputTableBody>
                                </div>
                            </div>
                            <div className="col-2">
                                {/* QR 결제 여부 */}
                                <div className="input-table-wrap w-100">
                                    <InputTableHead className="single">
                                        <h3>{t("paymentMethodSetting.qrPayment")}</h3>
                                    </InputTableHead>
                                    <InputTableBody>
                                        <div className="dp-flex align-cen w-100">
                                            <CmmnRadio
                                                    tagName="qrEnabled"
                                                    dataArray={qrYnArray}
                                                    defaultVal={getPaymentMethodOptions("qr")?.enabled === true ? 't': getPaymentMethodOptions("qr")?.enabled === false ? 'f':'' || '' }
                                                    onSelectChange={(e) => handlePaymentMethodChange('qr', 'enabled', e.target.value === "t" ? true:false)}
                                                />
                                        </div>
                                    </InputTableBody>
                                </div>
                            </div>
                        </InputTable>
                    </TableWrap>
                )}
                <TableWrap className="mt-40">
                    <h2>{t("prgmFrameSetting.title")}</h2>
                    <InputTable className="dp-flex">
                        <DlBox $length={filteredFrameArr.length}>
                            <div className="input-table-wrap">
                                <FrameTableHead style={{ minHeight: filteredFrameArr.some(frame => ["FBF1", "FBF2", "FSF2", "FSF4", "FSF5"].includes(frame.frameCd)) ? "88px" : "150px" }}><h3>{t("prgmFrameSetting.frame")}</h3></FrameTableHead>
                            </div>
                            <div className="input-table-wrap">
                                <FrameTableHead><h3>{t("prgmFrameSetting.lblBaseAmt")}</h3></FrameTableHead>
                            </div>
                            <div className="input-table-wrap">
                                <FrameTableHead><h3>{t("prgmFrameSetting.lblDisCntAmt")}</h3></FrameTableHead>
                            </div>
                            <div className="input-table-wrap">
                                <FrameTableHead><h3>{t("prgmFrameSetting.lblAddAmt")}</h3></FrameTableHead>
                            </div>
                            <div className="input-table-wrap">
                                <FrameTableHead><h3>{t("prgmFrameSetting.lblPrintPhotCnt")}</h3></FrameTableHead>
                            </div>
                            <div className="input-table-wrap">
                                <FrameTableHead><h3>{t("prgmFrameSetting.lblPhotoTakeCnt")}</h3></FrameTableHead>
                            </div>
                            <div className="input-table-wrap">
                                <FrameTableHead><h3>{t("prgmFrameSetting.lblFrameTakePhotoLimitTime")}</h3></FrameTableHead>
                            </div>
                            
                            <div className="input-table-wrap">
                                <FrameTableHead><h3>{t("prgmFrameSetting.lblFrameTag")}</h3></FrameTableHead>
                            </div>
                        </DlBox>
                        {filteredFrameArr.map((frame, index) => (
                            <Fragment key={`fragment_key_${index}`}>
                                <DlBox $length={filteredFrameArr.length}>
                                    <div className="input-table-wrap">
                                        <FrameTableHead style={{ minHeight: filteredFrameArr.some(frame => ["FBF1", "FBF2", "FSF2", "FSF4", "FSF5"].includes(frame.frameCd)) ? "88px" : "150px" }}>
                                            <h3>{t(`prgmFrameSetting.lbl${frame.frameCd}FrameExpl`)}</h3>
                                        </FrameTableHead>
                                    </div>
                                    <div className="input-table-wrap">
                                        <FrameTableBody>
                                            <TextFields
                                                key={`inputKey_0_${index}`}
                                                type="number"
                                                name="amtVal"
                                                value={parseInt(frame.amtVal)}
                                                onChangeValue={(e) => handleFrameSettingsChange(e, frame.frameCd)}
                                                className="w-100"
                                                step="100"
                                            />
                                        </FrameTableBody>
                                    </div>
                                    <div className="input-table-wrap">
                                        <FrameTableBody>
                                            <TextFields
                                                key={`inputKey_0_1_${index}`}
                                                type="number"
                                                name="discntAmtVal"
                                                value={parseInt(frame.discntAmtVal)}
                                                onChangeValue={(e) => handleFrameSettingsChange(e, frame.frameCd)}
                                                className="w-100"
                                                step="100"
                                            />
                                        </FrameTableBody>
                                    </div>
                                    <div className="input-table-wrap">
                                        <FrameTableBody>
                                            <TextFields
                                                key={`inputKey_1_${index}`}
                                                type="number"
                                                name="addAmtVal"
                                                value={parseInt(frame.addAmtVal)}
                                                onChangeValue={(e) => handleFrameSettingsChange(e, frame.frameCd)}
                                                className="w-100"
                                                step="100"
                                            />
                                        </FrameTableBody>
                                    </div>
                                    <div className="input-table-wrap">
                                        <FrameTableBody $cutYn={frame.frameInfo.cutYn === 'Y'} $errors={!!errors?.[frame.frameCd]}>
                                            <>
                                                {frame.frameInfo.cutYn === 'Y' &&
                                                    <div className="description"><p>※ {t("prgmFrameSetting.evenNumber")}</p></div>
                                                }
                                                <TextFields
                                                    key={`inputKey_2_${index}`}
                                                    type="number"
                                                    name="basePhotoCnt"
                                                    value={frame.basePhotoCnt === "" || isNaN(frame.basePhotoCnt) ? "" : Number(frame.basePhotoCnt)}
                                                    step={frame.frameInfo.cutYn === 'Y' ? 2 : 1}
                                                    min={frame.frameInfo.cutYn === 'Y' ? 2 : 1}
                                                    onChangeValue={(e) => handleFrameSettingsChange(e, frame.frameCd)}
                                                    className="w-100"
                                                />
                                                {frame.frameInfo.cutYn === 'Y' && errors?.[frame.frameCd] && (
                                                    <div className="error-message"><p>{errors[frame.frameCd]}</p></div>
                                                )}
                                            </>
                                        </FrameTableBody>
                                    </div>
                                    <div className="input-table-wrap">
                                        <FrameTableBody>
                                            <TextFields
                                                key={`inputKey_3_${index}`}
                                                type="number"
                                                name="takePhotoCnt"
                                                value={parseInt(frame.takePhotoCnt)}
                                                onChangeValue={(e) => handleFrameSettingsChange(e, frame.frameCd)}
                                                className="w-100"
                                            />
                                        </FrameTableBody>
                                    </div>
                                    <div className="input-table-wrap">
                                        <FrameTableBody>
                                            <TextFields
                                                key={`inputKey_4_${index}`}
                                                type="number"
                                                name="frameTakePhotoLimitTime"
                                                value={parseInt(frame.frameTakePhotoLimitTime)}
                                                onChangeValue={(e) => handleFrameSettingsChange(e, frame.frameCd)}
                                                className="w-100"
                                            />
                                        </FrameTableBody>
                                    </div>
                                    <div className="input-table-wrap">
                                        <FrameTableBody>
                                            <SelectBox
                                                defaultOptTxt={t("common.selectLable")}
                                                dataArray={frameTagArray}
                                                onSelectChange={(e) => handleFrameSettingsChange(e, frame.frameCd)}
                                                tagName="frameTag"
                                                defaultVal={frame.frameTag || ""}
                                                disabled={frame.photoModeCd === "B"}
                                            />
                                        </FrameTableBody>
                                    </div>
                                </DlBox>
                            </Fragment>
                        ))}
                    </InputTable>
                </TableWrap>
            </div>
            <BtnWrap>
                <ButtonUtil className="btn btn-danger round-filled-small-btn"
                    value={t("common.lblInitBtn")}
                    onClick={() => { handleCmmnBtnClick("cmmnResetBtn") }}
                />
                <ButtonUtil className="btn btn-outline-light round-solid-medium-btn"
                    value={t("common.cancelLable")}
                    onClick={() => { onHide() }}
                />
                <ButtonUtil className="btn btn-danger round-filled-small-btn"
                    value={t("common.saveLable")}
                    onClick={() => { handleCmmnBtnClick("cmmnInsertBtn") }}
                />
            </BtnWrap>
        </>
    )
}
